


// import React, { useEffect, useRef, useState } from 'react';
// import { Image, NativeBaseProvider, } from 'native-base';
// import { View, Text, Keyboard, TouchableWithoutFeedback, StyleSheet, TouchableOpacity, Alert, ActivityIndicator, Platform, BackHandler, Linking } from 'react-native';



// import { useDispatch } from 'react-redux';
// import AsyncStorage from '@react-native-async-storage/async-storage';
// import OTPTextInput from 'react-native-otp-textinput'
// import { MaterialCommunityIcons } from "@expo/vector-icons"
// import Btn from '../components/btn';
// import Colors from '../constants/Colors';
// import { login, sendOtp, setAccessToken } from "../store/action/userLogin";
// import AwesomeAlert from 'react-native-awesome-alerts';



// function OTPscreen(props) {
//   const dispatch = useDispatch();
//   const [otp, setotp] = useState("")
//   const [mytime, setmyTime] = useState(60);
//   const [show, setShow] = useState(false);
//   const [Loading, setLoading] = useState(false);
//   const [messages, setmessage] = useState("")
 
  
//   useEffect(() => {
    
//     const timer = setTimeout(() => {
//       if (mytime !== 0) {
//         setmyTime(mytime - 1);
//       }
//     }, 1000);
//     return () => {
//       clearTimeout(timer);
//     };

//   });



//   const loginHandler = async () => {
//     try {
//       setLoading(true);
//       const respo = await dispatch(
//         login(
//           props.route.params.number,
//           otp
//         )
//       );

//       //console.log(respo);
//       if (respo.status == "error") {
//         setShow(true)
//         setmessage(respo.message)
//         //props.navigation.navigate("register1")
//       }
//       if (respo.status == "success") {
//         await AsyncStorage.setItem("access_token", respo.data.token);
//         await dispatch(setAccessToken(respo.data.token))
//         if (respo.data.user.state_id == null) {
//           props.navigation.navigate("register1")
          
//         } else {
//           props.navigation.navigate("home")
          
//         }


//       }


//       setLoading(false);
//     } catch (err) {
//       console.log(err.name);
//       console.log("err");
//     }
//   };




//   const sendOtpHandler = async () => {
//     try {
//       const time = await sendOtp(props.route.params.number);
//       setmyTime(60);
//     } catch (err) {
//       console.log(err);
//     }
//   };

  
//   const handleOpencall = () => {
//     Linking.openURL(`tel:${"09120177198"}`);
// };
  


// const otpInput = useRef(null);

// const clearText = () => {
//     otpInput.current.clear();
// }



//   return (
//     <NativeBaseProvider>
    
//       <TouchableWithoutFeedback onPress={() => Keyboard.dismiss()}>


//         <View style={styles.viewContainer}>



//           <View style={styles.viewlogo}>

//             <Text style={{ fontFamily: "MontserratBold", fontSize: 20, bottom: 10, position: "absolute", marginBottom:Platform.OS=="web"?"18%":  "12%" }}>کد فعالسازی را وارد کنید</Text>
//             <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3 }}>کد 5 رقمی ارسال شده به شماره همراه {props.route.params.number} وارد کنید </Text>
           
//           </View>
 



//           <View style={styles.viewotp}>

//             <OTPTextInput
            
//               inputCount={5}
//               tintColor={Colors.primary}
//               containerStyle={{ marginBottom: 30 }}
//               textInputStyle={{
//                 right:10, borderRadius: 10, height: 60,
//                 borderWidth: 2.5, marginLeft: "5%"
//               }}
//               handleTextChange={(otp) => setotp(otp)}
//               ref={otpInput}
//             />

//           </View>

//           <TouchableOpacity style={{ alignItems: "center", marginRight: "30%" }} onPress={() => props.navigation.navigate("login")} >
//             <Text style={styles.fonttext}>تغییر شماره</Text>
//           </TouchableOpacity>

//           <View style={styles.viewtimer}>
//             <Text style={styles.fonttext}>

//               {mytime > 0 ? mytime :
//                 <TouchableOpacity onPress={sendOtpHandler} >
//                   <Text style={styles.fonttext1}>ارسال مجدد کد</Text>
//                 </TouchableOpacity>
//               }

//             </Text>
//           </View>



//           <TouchableOpacity style={{width:"100%",height:50,alignItems:"center",justifyContent:"center",top:40}} onPress={() =>handleOpencall() }  >
//                     <MaterialCommunityIcons name={"face-agent"} size={40} color={Colors.primary} />
//                     <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.primary }}>تماس با پشتیبانی</Text>
//                 </TouchableOpacity>



//           <Btn
//             label="تایید کد"
//             style={{ marginLeft: "5%", marginTop: 100, }}
//             textStyle={{ bottom: 10 }}
//             loading={Loading}
//             colorspin={Colors.background}
//             sizespin={25}
//             touchableStyle={{
//               backgroundColor:
//                 otp.length === 5
//                   ? Colors.primary
//                   : Colors.secondText,
//             }}
            
//             // onPress={()=>props.navigation.navigate("register1")}
//             onPress={
//               () => {
//                 if (otp.length === 5) {
//                   loginHandler()
                  
//                      clearText()
                  
                 
//                 } else {
//                   Alert.alert("اخطار",
//                     "کد را صحیح وارد کنید",
//                     [
//                       { text: "باشه", }
//                     ],

//                   )
//                 }
//               }}
//           />



//           <AwesomeAlert
//             show={show}
//             showProgress={false}
//             title="خطا!"
//             message={messages}
//             closeOnTouchOutside={true}
//             closeOnHardwareBackPress={false}
//             // showCancelButton={true}
//             showConfirmButton={true}
//             // cancelText="باشه"
//             confirmText="باشه"
//             confirmButtonColor="#DD6B55"
//             // onCancelPressed={() => {
//             //   setShow(false);
//             // }}
//             onConfirmPressed={() => {
//               setShow(false);
//             }}
//             titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: Colors.primarydark }}
//             messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
//             confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
//           />

//         </View>

//       </TouchableWithoutFeedback>

//     </NativeBaseProvider>
//   );
// }

// const styles = StyleSheet.create({

//   viewContainer: {
//     width: "100%",
//     height: "100%",
//     backgroundColor: Colors.background,
//     position:Platform.OS=="web"?"fixed":"relative"
//   },
//   viewlogo: {
//     width: "100%",
//     height: 100,
//     alignItems: "center",
//     justifyContent: "center",
//     marginTop: "20%"
//   },
//   imagelogo: {
//     width: 110,
//     height: 140,
//   },
//   textlogo: {
//     fontFamily: "Montserrat",
//     fontSize: 24,
//     position: "absolute",
//     top: "90%"
//   },
//   viewotp: {
//     justifyContent: 'center',
//     alignItems: 'center',
//     marginTop: "15%",
//     marginRight:Platform.OS=="web"?"20%":0 
//   },
//   fonttext: {
//     fontFamily: "Montserrat",
//     fontSize: 15,
//     color: Colors.primary
//   },
//   fonttext1: {
//     fontFamily: "Montserrat",
//     fontSize: 15,
//     color: Colors.primary,
//     top:Platform.OS=="web"?50:0
//   },
//   viewtimer: {
//     width: 100,
//     height: 20,
//     alignItems: "center",
//     position: "relative",
//     left: 190,
//     bottom: 26,
    
//   },
//   fielotp: {
//     width: 45,
//     height: 60,
//     borderWidth: 1,
//     margin: 2,
//     color: 'black',
//   }
// })
// export default OTPscreen






import React, {
  useCallback,
  useReducer,
  useRef,
  useState,
  useEffect,
} from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ScrollView,
  Platform,
} from "react-native";

import AsyncStorage from "@react-native-async-storage/async-storage";
import Inputak from "../components/Inputak";
import Btn from '../components/btn';
import Colors from '../constants/Colors';
import { useDispatch } from 'react-redux';
import { login, sendOtp, setAccessToken } from "../store/action/userLogin";
import { NativeBaseProvider, useMediaQuery } from "native-base";


const FORM_INPUT_UPDATE = "FORM_INPUT_UPDATE";
const formReducer = (state, action) => {
  // You don't need any changes
  if (action.type === FORM_INPUT_UPDATE) {
    let updatedInputValues = {
      ...state.inputValues,
      [action.id]: action.value,
      ["numAdded"]:
        state.inputValues.num1 +
        state.inputValues.num2 +
        state.inputValues.num3 +
        state.inputValues.num4 +
        state.inputValues.num5,
      // state.inputValues.num6,
    };
    let updatedInputValidities = {
      ...state.inputValidities,
      [action.id]: action.validity,
    };
    let updatedFormValidity = true;
    for (const key in updatedInputValidities) {
      updatedFormValidity = updatedInputValidities[key] && updatedFormValidity;
    }
    return {
      inputValues: updatedInputValues,
      inputValidities: updatedInputValidities,
      formValidity: updatedFormValidity,
    };
  }
  return state;
};






const OTPscreen = (props) => {
  const dispatch = useDispatch();
  const [login_msg, setlogin_msg] = useState("");
  const [mytime, setmyTime] = useState(60);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (mytime !== 0) {
        setmyTime(mytime - 1);
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  });

  const inum1 = useRef(null);
  const inum2 = useRef(null);
  const inum3 = useRef(null);
  const inum4 = useRef(null);
  const inum5 = useRef(null);
  // const inum6 = useRef(null);
  const [formState, dispatchFormState] = useReducer(formReducer, {
    // You should make changes according to input ids
    inputValues: {
      num1: "",
      num2: "",
      num3: "",
      num4: "",
      num5: "",
      // num6: "",
      numAdded: "",
    },
    inputValidities: {
      num1: false,
      num2: false,
      num3: false,
      num4: false,
      num5: false,
      // num6: false,
    },
    formValidity: false,
  });
  const inputChangeHandler = useCallback(
    // You don't need any changes
    (id, value, validity) => {
      dispatchFormState({
        type: FORM_INPUT_UPDATE,
        value,
        id,
        validity,
      });
      switch (id) {
        case "num1":
          if (value != "") {
            inum2.current.focus();
          }
          break;
        case "num2":
          if (value != "") {
            inum3.current.focus();
          }
          break;
        case "num3":
          if (value != "") {
            inum4.current.focus();
          }
          break;
        case "num4":
          if (value != "") {
            inum5.current.focus();
          }
          break;
        case "num5":
          if (value != "") {
            inum5.current.blur();
          }
          break;
        // case "num6":
        //   if (value != "") {
        //     inum6.current.blur();
        //   }
        //   break;
      }
    },
    [dispatchFormState]
  );


  const loginHandler = async () => {
    try {
      setLoading(true);
      const respo = await dispatch(
        login(
          props.route.params.number,
          formState.inputValues.numAdded
        )
      );

      // console.log(respo);
      if (respo.status == "error") {
        setlogin_msg(respo.message)
        //props.navigation.navigate("register1")
      }
      if (respo.status == "success") {
        await AsyncStorage.setItem("access_token", respo.data.token);
        await dispatch(setAccessToken(respo.data.token))
        if (respo.data.user.state_id == null) {
          props.navigation.navigate("register1")
        } else {
          props.navigation.navigate("home")
        }


      }


      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };



  


  const sendOtpHandler = async () => {
    try {
      const time = await sendOtp(props.route.params.number);
      setmyTime(60);
    } catch (err) {
      console.log(err);
    }
  };

  
const [isSmallScreen] = useMediaQuery({
  // minHeight: 280,
  // maxHeight: 480,
  maxWidth: 500
});


  return (
    <NativeBaseProvider>

    
    <View style={{
       width:isSmallScreen ? "100%" : 500,
       height: "100%",
       marginLeft: isSmallScreen ? 0 : "35%",
       backgroundColor: Colors.background,
       overflow: "hidden",
       position:Platform.OS=="web"?"fixed":"relative"
    }}>
      <View style={styles.scrollContainer}>
        <ScrollView showsVerticalScrollIndicator={false}>
          <View style={styles.logoContainer}>


            <Text style={{ fontFamily: "MontserratBold", fontSize: 20, bottom: 10, position: "absolute", marginBottom: "15%" }}>کد فعالسازی را وارد کنید</Text>
            <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.secondText3,position:"absolute",top: 50 }}>کد 5 رقمی ارسال شده به شماره همراه {props.route.params.number} وارد کنید </Text>

          </View>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Inputak
              onInputChange={inputChangeHandler}
              id={"num1"}
              inputref={inum1}
              styleinput={Platform.OS === "web" && { outlineColor: Colors.primary ,outlineStyle: 'none'}}
            />
            <Inputak
              onInputChange={inputChangeHandler}
              id={"num2"}
              inputref={inum2}
              styleinput={Platform.OS === "web" && { outlineColor: Colors.primary,outlineStyle: 'none' }}
            />
            <Inputak
              onInputChange={inputChangeHandler}
              id={"num3"}
              inputref={inum3}
              styleinput={Platform.OS === "web" && { outlineColor: Colors.primary,outlineStyle: 'none' }}
            />

            <Inputak
              onInputChange={inputChangeHandler}
              id={"num4"}
              inputref={inum4}
              styleinput={Platform.OS === "web" && { outlineColor: Colors.primary,outlineStyle: 'none' }}
            />
            <Inputak
              onInputChange={inputChangeHandler}
              id={"num5"}
              inputref={inum5}
              styleinput={Platform.OS === "web" && { outlineColor: Colors.primary,outlineStyle: 'none' }}
            />
            {/* <Inputak
              onInputChange={inputChangeHandler}
              id={"num6"}
              inputref={inum6}
              styleinput={Platform.OS === "web" && {outlineColor:Colors.primary }}
            /> */}
          </View>
          <View style={{ width: "100%", alignItems: "center" }}>
            <Text
              style={{
                fontFamily: "Montserrat",
                fontSize: 16,
                color: "red",
              }}
            >
              {login_msg}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: 80,
            }}
          >
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: 15,
              }}
              onPress={() => {
                props.navigation.navigate("login");
              }}
            >
              <Text style={styles.skiptext}>تغییر شماره</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
                marginTop: 15,
              }}
              onPress={mytime == 0 ? sendOtpHandler : () => { }}
            >
              {mytime !== 0 && (
                <Text style={styles.skiptext}>
                  {"    "} {"    "}00:{mytime}
                </Text>
              )}
              {mytime === 0 && (
                <Text style={styles.skiptext}>
                  ارسال مجدد کد
                  {"    "} {"    "}
                </Text>
              )}
            </TouchableOpacity>
          </View>
          <Btn
            label="تایید کد"

            textStyle={{ bottom: 10 }}
            onPress={() => {
              if (!loading && formState.inputValues.numAdded.length === 5) {
                loginHandler();
                // props.navigation.navigate("register1")
              }
            }}
            style={{ marginTop: 30, marginLeft: "5%" }}
            loading={loading}
            colorspin={Colors.background}
            sizespin={25}
            touchableStyle={{
              backgroundColor:
                formState.inputValues.numAdded.length === 5
                  ? Colors.primary
                  : Colors.secondText,
            }}
          />

        </ScrollView>
      </View>
    </View>
    </NativeBaseProvider>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width:"100%",
    height: "100%",
    backgroundColor: Colors.background,
    overflow: "hidden",
    position:Platform.OS=="web"?"fixed":"relative"

  },
  scrollContainer: {
    width: "100%",
    height: "100%",
    paddingHorizontal: 15,
    flex: 1,


  },
  logoContainer: {
    width: "100%",
    alignItems: "center",
    marginBottom: "70%",
    top: "30%"


  },
  skiptext: {
    fontFamily: "Montserrat",
    fontSize: 14,
    color: Colors.primary,
  },
});

export const screenOptions = {
  headerShown: false,
  gestureEnabled: false,
  animationEnabled: false,
};

export default OTPscreen;
